import { useEffect, useState } from "react";
import {decodeJWT, getCurrentToken} from "./accessTokenHelper.js";

const usePageAuthorization = ({ allowedRoles = [], setLoading }) => {
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    useEffect(() => {
        const token = getCurrentToken();
        if (token !== "") {
            const data = decodeJWT(token);
            if (data) {
                if (data.data.name === "SystemDefaultSuperAdmin") {
                    setIsSuperAdmin(true);
                    setIsAuthorized(true);
                    setLoading(false);
                    return;
                }

                try {
                    const userRoles = data.data.roles || [];
                    const authorized = userRoles.some(role => allowedRoles.includes(role.name));
                    setIsAuthorized(authorized);
                } catch {
                    setIsAuthorized(false);
                }
            }
        }
        setLoading(false);
    }, [allowedRoles]);

    return { isAuthorized, isSuperAdmin };
};

export default usePageAuthorization;
